import { render, staticRenderFns } from "./PageEditorSectionMoveUpBtn.vue?vue&type=template&id=013c0817&scoped=true"
import script from "./PageEditorSectionMoveUpBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorSectionMoveUpBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c0817",
  null
  
)

export default component.exports